import React, { useState } from 'react';
import classnames from 'classnames';
import { apiHolder as api } from 'api';
import { Button } from 'antd';
import { useAppSelector } from '@web-common/state/createStore';
import taskStyle from './taskMail.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import { getIn18Text } from 'api';
const storeApi = api.api.getDataStoreApi();
const GuideCard = () => {
    const infoStatus = useAppSelector(state => state.mailReducer.currentMail.status);
    const taskMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.taskMailShow;
    const [showCard, setShowCard] = useState(true);
    const followerCardHide = storeApi.getSync('followerCardHide').data;
    const clickKnow = () => {
        storeApi.put('followerCardHide', 'true');
        setShowCard(false);
    };
    return showCard && !followerCardHide && taskMailShow ? (React.createElement("div", { className: classnames(taskStyle.taskMailCard, taskStyle.followerCard) },
        React.createElement("span", { className: classnames(taskStyle.triangleIcon) },
            React.createElement(IconCard, { type: "upTriangle", width: "24", height: "12", fill: "#386ee7", fillOpacity: "1" })),
        React.createElement("div", { className: classnames(taskStyle.desc) }, getIn18Text('RENWUGUANZHUREN')),
        React.createElement("div", { className: classnames(taskStyle.footer) },
            React.createElement(Button, { className: classnames(taskStyle.btn, taskStyle.taskBtn), onClick: clickKnow }, getIn18Text('ZHIDAOLE'))))) : null;
};
export default GuideCard;
